import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "btn btn-light mr-auto" }
const _hoisted_4 = {
  class: "container",
  style: {"padding-top":"80px"}
}
const _hoisted_5 = {
  key: 0,
  id: "MeetingQuestion"
}
const _hoisted_6 = { style: {"min-height":"100vh","margin-top":"80px"} }
const _hoisted_7 = {
  class: "text-center lead",
  style: {"font-size":"1.5rem"}
}
const _hoisted_8 = { style: {"min-height":"450px"} }
const _hoisted_9 = { class: "PairwiseComparisonEditor" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }
const _hoisted_12 = { class: "mt1 ItemDetailsBox bg-color-blue3" }
const _hoisted_13 = { class: "btn-group ItemButton" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }
const _hoisted_16 = { class: "mt1 ItemDetailsBox bg-color-red3" }
const _hoisted_17 = { class: "btn-group ItemButton" }
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-sm-6 offset-sm-3 col-xs-12" }
const _hoisted_23 = {
  key: 0,
  class: "text-center"
}
const _hoisted_24 = { style: {"margin-top":"30px"} }
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  class: "mt-4",
  style: {"min-height":"500px"}
}
const _hoisted_27 = {
  key: 0,
  class: "PairwiseComparisonVotesBrowserView"
}
const _hoisted_28 = { class: "nav nav-tabs" }
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = { class: "nav-item" }
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = { class: "tab-content" }
const _hoisted_33 = { class: "table-responsive" }
const _hoisted_34 = { class: "table table-striped" }
const _hoisted_35 = {
  class: "clearfix",
  style: {"min-width":"510px","border-top":"0"}
}
const _hoisted_36 = {
  class: "clearfix pull-right",
  style: {"width":"85%"}
}
const _hoisted_37 = { class: "pull-left" }
const _hoisted_38 = { class: "pull-right" }
const _hoisted_39 = { style: {"text-align":"center"} }
const _hoisted_40 = { style: {"text-align":"left"} }
const _hoisted_41 = { style: {"padding":"0"} }
const _hoisted_42 = {
  class: "clearfix",
  style: {"list-style":"none","margin":"0","padding":"0"}
}
const _hoisted_43 = { style: {"text-align":"center"} }
const _hoisted_44 = { style: {"text-align":"left"} }
const _hoisted_45 = { style: {"padding":"0"} }
const _hoisted_46 = {
  class: "clearfix",
  style: {"list-style":"none","margin":"0","padding":"0"}
}
const _hoisted_47 = { class: "table-responsive" }
const _hoisted_48 = { class: "table" }
const _hoisted_49 = {
  style: {"text-align":"center"},
  class: "bottom noborder"
}
const _hoisted_50 = { style: {"height":"400px","border":"none","padding-top":"20px"} }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { style: {"text-align":"center"} }
const _hoisted_53 = { style: {"width":"6%"} }
const _hoisted_54 = ["colspan"]
const _hoisted_55 = ["colspan"]
const _hoisted_56 = { class: "blockquote" }
const _hoisted_57 = { class: "mb-0" }
const _hoisted_58 = { class: "blockquote-footer" }
const _hoisted_59 = {
  key: 1,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_60 = {
  key: 2,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_61 = { class: "card" }
const _hoisted_62 = { class: "card-body" }
const _hoisted_63 = { class: "btn btn-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionDetailsDialog = _resolveComponent("CriterionDetailsDialog")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionDetailsDialog, { viewModel: _ctx.criterionDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    (_ctx.viewTemplate === 'default')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("nav", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, [...(_cache[25] || (_cache[25] = [
                _createElementVNode("i", {
                  class: "fa fa-angle-double-left",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" My Survey ", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.dashboardUrl]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.question)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, [
                      _cache[26] || (_cache[26] = _createTextVNode(" In the context of ", -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "text-primary",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showContextCriterionDetails && _ctx.showContextCriterionDetails(...args))),
                        title: "Show details"
                      }, _toDisplayString(_ctx.contextName), 1 /* TEXT */),
                      _cache[27] || (_cache[27] = _createTextVNode(", which criterion is more important: ", -1 /* CACHED */)),
                      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "text-primary",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showFirstCriterionDetails && _ctx.showFirstCriterionDetails(...args))),
                        title: "Show details"
                      }, _toDisplayString(_ctx.firstCriterionName), 1 /* TEXT */),
                      _cache[29] || (_cache[29] = _createTextVNode(" or ", -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "text-primary",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showSecondCriterionDetails && _ctx.showSecondCriterionDetails(...args))),
                        title: "Show details"
                      }, _toDisplayString(_ctx.secondCriterionName), 1 /* TEXT */),
                      _cache[30] || (_cache[30] = _createTextVNode("? ", -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.firstCriterionName), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-block dropdown-toggle", _ctx.FirstSelected ? 'btn-success' : 'btn-outline-secondary']),
                                "data-toggle": "dropdown"
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fa-regular", _ctx.FirstSelected ? 'fa-square-check' : 'fa-square']),
                                  "aria-hidden": "true"
                                }, null, 2 /* CLASS */),
                                _createTextVNode(" " + _toDisplayString(_ctx.FirstBtnLabel), 1 /* TEXT */)
                              ], 2 /* CLASS */),
                              _createElementVNode("div", _hoisted_14, [
                                _cache[31] || (_cache[31] = _createElementVNode("h4", { class: "dropdown-header" }, "How much more important?", -1 /* CACHED */)),
                                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(2)))
                                }, "Weak (2)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(3)))
                                }, "Moderate (3)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(4)))
                                }, "Moderate + (4)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(5)))
                                }, "Strong (5)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(6)))
                                }, "Strong + (6)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(7)))
                                }, "Very strong (7)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(8)))
                                }, "Very strong + (8)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(9)))
                                }, "Extreme (9)")
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.secondCriterionName), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-block dropdown-toggle", _ctx.SecondSelected ? 'btn-success' : 'btn-outline-secondary']),
                                "data-toggle": "dropdown"
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["fa-regular", _ctx.SecondSelected ? 'fa-square-check' : 'fa-square']),
                                  "aria-hidden": "true"
                                }, null, 2 /* CLASS */),
                                _createTextVNode(" " + _toDisplayString(_ctx.SecondBtnLabel), 1 /* TEXT */)
                              ], 2 /* CLASS */),
                              _createElementVNode("div", _hoisted_18, [
                                _cache[33] || (_cache[33] = _createElementVNode("h4", { class: "dropdown-header" }, "How much more important?", -1 /* CACHED */)),
                                _cache[34] || (_cache[34] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0/2.0)))
                                }, "Weak (2)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0/3.0)))
                                }, "Moderate (3)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0/4.0)))
                                }, "Moderate + (4)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0/5.0)))
                                }, "Strong (5)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0/6.0)))
                                }, "Strong + (6)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0/7.0)))
                                }, "Very strong (7)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0/8.0)))
                                }, "Very strong + (8)"),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0/9.0)))
                                }, "Extreme (9)")
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["btn btn-block btn-equal mt1", _ctx.EqualitySelected === true ? 'btn-success' : 'btn-outline-secondary']),
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(1.0)))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fa-regular", _ctx.EqualitySelected === true ? 'fa-square-check' : 'fa-square']),
                                "aria-hidden": "true"
                              }, null, 2 /* CLASS */),
                              _cache[35] || (_cache[35] = _createTextVNode(" Equally important (1) ", -1 /* CACHED */))
                            ], 2 /* CLASS */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            (_ctx.Value != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-link mt1",
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSavePanelistVoteCommand(null)))
                                  }, [...(_cache[36] || (_cache[36] = [
                                    _createElementVNode("i", {
                                      class: "fa fa-times",
                                      "aria-hidden": "true"
                                    }, null, -1 /* CACHED */),
                                    _createTextVNode(" Clear answer ", -1 /* CACHED */)
                                  ]))])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _cache[37] || (_cache[37] = _createElementVNode("h5", { style: {"margin-bottom":"5px"} }, "Comment:", -1 /* CACHED */)),
                          _createElementVNode("textarea", {
                            rows: "5",
                            value: _ctx.Comment,
                            onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleSavePanelistVoteCommentCommand($event.target.value))),
                            class: "form-control",
                            placeholder: "Comment..."
                          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_25)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      (_ctx.votesEntries)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("ul", _hoisted_28, [
                              _createElementVNode("li", _hoisted_29, [
                                _createElementVNode("a", {
                                  class: _normalizeClass(["nav-link", {'active': _ctx.browserActiveTab === 'votes'}]),
                                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.browserActiveTab = 'votes'))
                                }, "Votes", 2 /* CLASS */)
                              ]),
                              _createElementVNode("li", _hoisted_30, [
                                _createElementVNode("a", {
                                  class: _normalizeClass(["nav-link", {'active': _ctx.browserActiveTab === 'summary'}]),
                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.browserActiveTab = 'summary'))
                                }, "Chart", 2 /* CLASS */)
                              ]),
                              _createElementVNode("li", _hoisted_31, [
                                _createElementVNode("a", {
                                  class: _normalizeClass(["nav-link", {'active': _ctx.browserActiveTab === 'comments'}]),
                                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.browserActiveTab = 'comments'))
                                }, "Comments", 2 /* CLASS */)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              (_ctx.browserActiveTab === 'votes')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["tab-pane pt-2", {'active': _ctx.browserActiveTab === 'votes'}])
                                  }, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("table", _hoisted_34, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _cache[39] || (_cache[39] = _createElementVNode("th", { style: {"border-top":"0"} }, null, -1 /* CACHED */)),
                                            _createElementVNode("th", _hoisted_35, [
                                              _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.firstCriterionName), 1 /* TEXT */),
                                                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.secondCriterionName), 1 /* TEXT */),
                                                _cache[38] || (_cache[38] = _createElementVNode("div", {
                                                  class: "text-center",
                                                  style: {"margin":"0 auto","width":"50px"}
                                                }, "vs", -1 /* CACHED */))
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          _createElementVNode("tr", _hoisted_39, [
                                            _createElementVNode("td", _hoisted_40, [
                                              _createElementVNode("strong", null, "Average (" + _toDisplayString(_ctx.AverageDescription) + ")", 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("td", _hoisted_41, [
                                              _createElementVNode("ul", _hoisted_42, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ScaleView1, (scaleValue) => {
                                                  return (_openBlock(), _createElementBlock("li", {
                                                    class: _normalizeClass(_ctx.GetCssClass(scaleValue, _ctx.Average))
                                                  }, _toDisplayString(_ctx.GetScaleItemText(scaleValue, _ctx.Average)), 3 /* TEXT, CLASS */))
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                              ])
                                            ])
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.VotesEntriesView, (voteEntry) => {
                                            return (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                                              _createElementVNode("td", _hoisted_44, _toDisplayString(voteEntry.VotesSourceName), 1 /* TEXT */),
                                              _createElementVNode("td", _hoisted_45, [
                                                _createElementVNode("ul", _hoisted_46, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ScaleView1, (scaleValue) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                      class: _normalizeClass(_ctx.GetCssClass(scaleValue, voteEntry.Value))
                                                    }, _toDisplayString(_ctx.GetScaleItemText(scaleValue, voteEntry.Value)), 3 /* TEXT, CLASS */))
                                                  }), 256 /* UNKEYED_FRAGMENT */))
                                                ])
                                              ])
                                            ]))
                                          }), 256 /* UNKEYED_FRAGMENT */))
                                        ])
                                      ])
                                    ])
                                  ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true),
                              (_ctx.browserActiveTab === 'summary')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["tab-pane pt-2", {'active': _ctx.browserActiveTab === 'summary'}])
                                  }, [
                                    _createElementVNode("div", _hoisted_47, [
                                      _createElementVNode("table", _hoisted_48, [
                                        _createElementVNode("tbody", null, [
                                          _createElementVNode("tr", _hoisted_49, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HistogramValues, (v) => {
                                              return (_openBlock(), _createElementBlock("td", _hoisted_50, [
                                                (v.Count)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      innerHTML: v.Count
                                                    }, null, 8 /* PROPS */, _hoisted_51))
                                                  : _createCommentVNode("v-if", true),
                                                _createElementVNode("div", {
                                                  style: _normalizeStyle({'height': `${v.PercentOfMax}%`}),
                                                  class: _normalizeClass([_ctx.GetColor(v.Value), "bg-color-blue2"])
                                                }, " ", 6 /* CLASS, STYLE */)
                                              ]))
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                          ]),
                                          _createElementVNode("tr", _hoisted_52, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HistogramScale, (hs) => {
                                              return (_openBlock(), _createElementBlock("td", _hoisted_53, _toDisplayString(_ctx.FormatValue(hs).toFixedIfNeeded(2)), 1 /* TEXT */))
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                          ])
                                        ]),
                                        _createElementVNode("tfoot", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                              colspan: _ctx.LeftScaleValuesCount,
                                              style: {"text-align":"left"}
                                            }, _toDisplayString(_ctx.firstCriterionName), 9 /* TEXT, PROPS */, _hoisted_54),
                                            _cache[40] || (_cache[40] = _createElementVNode("th", { style: {"text-align":"center"} }, "vs", -1 /* CACHED */)),
                                            _createElementVNode("th", {
                                              colspan: _ctx.RightScaleValuesCount,
                                              style: {"text-align":"right"}
                                            }, _toDisplayString(_ctx.secondCriterionName), 9 /* TEXT, PROPS */, _hoisted_55)
                                          ])
                                        ])
                                      ])
                                    ])
                                  ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true),
                              (_ctx.browserActiveTab === 'comments')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["tab-pane pt-2", {'active': _ctx.browserActiveTab === 'comments'}])
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Comments, (c) => {
                                      return (_openBlock(), _createElementBlock("blockquote", _hoisted_56, [
                                        _createElementVNode("p", _hoisted_57, _toDisplayString(c.Comment), 1 /* TEXT */),
                                        _createElementVNode("footer", _hoisted_58, _toDisplayString(c.VotesSourceName), 1 /* TEXT */)
                                      ]))
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                  ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'connecting')
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [...(_cache[41] || (_cache[41] = [
          _createStaticVNode("<div class=\"card\" data-v-1f04a13c><div class=\"card-body\" data-v-1f04a13c><h5 class=\"card-title\" data-v-1f04a13c><i class=\"fa fa-spinner fa-spin\" data-v-1f04a13c></i> Connecting...</h5><p class=\"card-text lead\" data-v-1f04a13c>We are checking if meeting was started by the host.</p><br data-v-1f04a13c></div></div>", 1)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'notStarted')
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _cache[43] || (_cache[43] = _createElementVNode("h5", { class: "card-title" }, "Meeting is not started", -1 /* CACHED */)),
              _cache[44] || (_cache[44] = _createElementVNode("p", { class: "card-text lead" }, "Please wait for the host to start this meeting.", -1 /* CACHED */)),
              _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_63, [...(_cache[42] || (_cache[42] = [
                _createTextVNode("Go to the survey", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.dashboardUrl]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}